module.exports = __webpack_public_path__ + "dd52e3974d75428a659039a45289f503.svg";